export function getInitialRegistrationData(data){
   const  {
        dob, email, empStartDate, fatherName, firstName, gender, lastName, loanAmountRequsted, loanTerm, loanType, martialStatus, middleName, occupation, phoneNumber
      } = data;
      return {
        dob, email, empStartDate, fatherName, firstName, gender, lastName, loanAmountRequsted, loanTerm, loanType, martialStatus, middleName, occupation, phoneNumber
      };
}
